import { AxiosResponse } from 'axios';
import { EocEmailMetrics } from './EocEmailMetrics';
import VersionedResource from '../VersionedResource';

export default class EocEmailMetricsResource extends VersionedResource {
  public async get(fiId: string, cycleId: number) : Promise<EocEmailMetrics> {
    const url = `/api/rcx/config/${fiId}/eoc-email-settings/query-eoc-email/${cycleId}`;

    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if EocEmailMetrics isn't available, so return null
      if (error.response.status !== 404) {
        throw error;
      } else {
        return EocEmailMetricsResource.createEmptyEocEmailMetrics();
      }
    }
  }


  public static createEmptyEocEmailMetrics() : EocEmailMetrics {
    return {
      externalProductMappingIdEmailCounts: null!,
    };
  }
}
